import React, {Component} from 'react';
import FaqContent from '../function-components/FaqContent'

function Faq() {
    return (
      <>
          <FaqContent />
      </>
    )
  }

export default Faq;